"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.getChartOptions = exports.makeChartGraph = exports.assignXValue = exports.calculateCFO = exports.filterExpWithImpIg = exports.filterZeroImpactIgnorance = exports.getGroupedData = exports.generateSeries = exports.makeColor = exports.getChartHeight = void 0;
var Highcharts = require("highcharts");
var MAX_CHART_HEIGHT = 100000;
function getChartHeight(numOfBars) {
    var base = 40;
    return Math.min(MAX_CHART_HEIGHT, numOfBars * base + 100);
}
exports.getChartHeight = getChartHeight;
var markerMap = {
    Discovery: "diamond",
    Navigate: "righttriangle",
    Specify: "lefttriangle",
    Manage: "downtriangle"
};
var sortingOptions = {
    Alpha: "alpha",
    AlphaDesc: "alphaDESC",
    Value: "value"
};
function breakDownSeries(seriesData) {
    var breakDownSeries = [];
    seriesData.forEach(function (row) {
        breakDownSeries.push(__assign(__assign({}, row), { ol: row.low, oh: row.high, high: row.base }));
        breakDownSeries.push(__assign(__assign({}, row), { ol: row.low, oh: row.high, low: row.base }));
    });
    return breakDownSeries;
}
function makeColor(colorNum) {
    var hues = [
        0, 20, 30, 40, 50, 60, 80, 120, 160, 190, 210, 230, 260, 290, 330, 360,
    ];
    //hues = [...Array(37).keys()].map(x=>x*10);
    var lights = [60, 50, 50, 50, 50, 50, 50, 55, 50, 55, 67, 77, 73, 67, 60, 60];
    var goldenFrac = 0.5 * (3 - Math.sqrt(5));
    var x = ((colorNum * goldenFrac) % 1.0) * (hues.length - 1);
    //x=colorNum%(hues.length-1); // for point visualisation
    var i = Math.floor(x);
    var f = x % 1.0;
    var hue = (1.0 - f) * hues[i] + f * hues[i + 1];
    var light = (1.0 - f) * lights[i] + f * lights[i + 1];
    return ("hsl( " +
        Math.round(hue * 100) / 100 +
        ", 100%, " +
        Math.round(light * 100) / 100 +
        "% )");
}
exports.makeColor = makeColor;
function returnSortedObject(originalObject, yAxisSort, yAxisKey) {
    var sortedObject = __assign({}, originalObject);
    if (yAxisSort == sortingOptions.Alpha) {
        sortedObject = Object.keys(originalObject)
            .sort()
            .reduce(function (acc, key) {
            acc[key] = originalObject[key];
            return acc;
        }, {});
    }
    else if (yAxisSort == sortingOptions.AlphaDesc) {
        sortedObject = Object.keys(originalObject)
            .sort(function (a, b) { return b.localeCompare(a); }) // Sort keys in descending order
            .reduce(function (acc, key) {
            acc[key] = originalObject[key];
            return acc;
        }, {});
    }
    else if (yAxisSort == sortingOptions.Value) {
        sortedObject = Object.keys(originalObject)
            .sort(function (keyA, keyB) {
            var maxValueA = Math.max.apply(Math, originalObject[keyA].map(function (item) { return item[yAxisKey]; }));
            var maxValueB = Math.max.apply(Math, originalObject[keyB].map(function (item) { return item[yAxisKey]; }));
            return maxValueB - maxValueA;
        })
            .reduce(function (acc, key) {
            acc[key] = originalObject[key];
            return acc;
        }, {});
    }
    return sortedObject;
}
function generateSeries(data, xAxis, yAxis, settings) {
    var groupByName = data.groupByName, projectColor = data.projectColor;
    var yAxisSort = yAxis['data'][yAxis['selected']]['sort'];
    var yAxisKey = yAxis['data'][yAxis['selected']]['key'];
    var xAxisKey = xAxis['data'][xAxis['selected']]['key'];
    var series = [];
    series.push({
        name: "<div style='font-size: 12pt;'><strong>Projects</strong></div>",
        color: "#ffffff00",
        data: {},
        marker: {
            radius: 1,
            symbol: ""
        },
        events: {
            legendItemClick: function (e) {
                e.preventDefault();
            }
        }
    });
    // Create an empty array to hold the line data
    var lineData = [];
    //sending "alpha" as sorting option, as required 
    groupByName = returnSortedObject(groupByName, "alpha", yAxisKey);
    // Create a series for each project
    Object.entries(groupByName).forEach(function (e, index) {
        var key = e[0], value = e[1];
        console.log(index, key, projectColor["key"], value);
        var data = [];
        // Create an array to store the y values from this series
        var yValues = [];
        var xValues = [];
        value.forEach(function (v) {
            var marker = {};
            if (v.DiscoveryGrid) {
                // Decide whether marker should be filled or empty
                if (v.Experiments === "No") {
                    marker["fillColor"] = "#F1F1F711";
                    marker["lineWidth"] = 3;
                    marker["lineColor"] = projectColor[key.replace(/\s\s+/g, "_")];
                }
                marker["symbol"] = "circle";
                if (v.impact != 0 && v.ignorance != 0) {
                    var xValue = v['cx'];
                    var yValue = v['cy']; // Get the y-axis data value
                    yValues.push(yValue); // Store the y value
                    xValues.push(xValue); // Store the x value
                    data.push({
                        x: xValue,
                        y: yValue,
                        marker: marker,
                        options: {
                            expName: v.expName,
                            xData: v[xAxisKey],
                            yData: v[yAxisKey],
                            slope: v.slope
                        }
                    });
                }
            }
        });
        console.log("color: ", key, projectColor.key);
        // Create the line data for this series based on y values
        var lineDataForSeries = yValues.map(function (yValue, i) { return [xValues[i], yValue]; });
        lineData.push.apply(lineData, lineDataForSeries);
        series.push({
            name: "<div style='font-weight: normal;'>" + key + "</div>",
            id: index,
            color: projectColor[key.replace(/\s\s+/g, "_")],
            marker: {
                radius: 10,
                symbol: "circle"
            },
            data: data
        });
    });
    lineData.sort(function (a, b) { return a[0] - b[0]; });
    series.push({
        name: 'Line',
        type: 'line',
        data: lineData,
        showInLegend: false,
        enableMouseTracking: false,
        states: {
            hover: {
                enabled: false
            }
        }
    });
    return series;
}
exports.generateSeries = generateSeries;
function getGroupedData(tableJSON) {
    var a = tableJSON.sort(function (a, b) { return (a.ValueGIvenSuccess < b.ValueGIvenSuccess ? 1 : -1); });
    var projects = __spreadArray([], (tableJSON.map(function (obj) { return obj.name; })), true).sort();
    var projectColor = {};
    projects.forEach(function (p, index) { return (projectColor[p.replace(/\s\s+/g, "_")] = makeColor(index)); });
    var result = tableJSON.reduce(function (r, _a) {
        var name = _a.name, rest = __rest(_a, ["name"]);
        if (!r[name]) {
            r[name] = { name: name, data: [rest] };
        }
        else {
            r[name].data.push(rest);
        }
        return r;
    }, {});
    var groupBy = function (array, property) {
        return array.reduce(function (grouped, element) {
            var _a;
            return (__assign(__assign({}, grouped), (_a = {}, _a[element[property]] = __spreadArray(__spreadArray([], (grouped[element[property]] || []), true), [element], false), _a)));
        }, {});
    };
    var groupByName = groupBy(tableJSON, "name");
    return { groupByName: groupByName, projectColor: projectColor };
}
exports.getGroupedData = getGroupedData;
function filterZeroImpactIgnorance(dataGot) {
    return dataGot.filter(function (item) { return item.impact > 0 && item.ignorance > 0 && (item.title != "" || item.issue != ""); });
}
exports.filterZeroImpactIgnorance = filterZeroImpactIgnorance;
function filterExpWithImpIg(dataGot) {
    return dataGot.filter(function (item) {
        if (item.Experiments === "Yes" && item.impact > 0 && item.ignorance > 0 && (item.title != "" || item.issue != "")) {
            if (item.expName === "" || item.expName === null) {
                item.expName = "Unnamed";
            }
            return true;
        }
        return false;
    });
}
exports.filterExpWithImpIg = filterExpWithImpIg;
function calculateCFO(dataGot, xAxis, yAxis) {
    var xAxisKey = xAxis['data'][xAxis['selected']]['key'];
    var yAxisKey = yAxis['data'][yAxis['selected']]['key'];
    dataGot.forEach(function (obj) {
        var xValue = obj[xAxisKey];
        var yValue = obj[yAxisKey];
        obj.slope = yValue / xValue;
    });
    // Sort dataGot based on the slope in descending order (highest to lowest)
    dataGot.sort(function (a, b) { return b.slope - a.slope; });
    // Calculate the cumulative values cx and cy
    calculateCumulative(dataGot, xAxisKey, yAxisKey);
    return dataGot;
}
exports.calculateCFO = calculateCFO;
function calculateCumulative(dataGot, xAxisKey, yAxisKey) {
    var cx = 0;
    var cy = 0;
    dataGot.forEach(function (obj) {
        var xValue = obj[xAxisKey];
        var yValue = obj[yAxisKey];
        // Calculate cumulative values
        cx += xValue;
        cy += yValue;
        // Assign cx and cy attributes to the object
        obj.cx = cx;
        obj.cy = cy;
    });
}
function assignXValue(mainSeriesData, siblingSeriesData) {
    var totalBars = mainSeriesData.length;
    mainSeriesData.forEach(function (row, index) {
        row.x = index;
    });
    if (siblingSeriesData && siblingSeriesData.length > 0) {
        var positionFix_1 = 0.42;
        mainSeriesData.forEach(function (row, index) {
            for (var _i = 0, siblingSeriesData_1 = siblingSeriesData; _i < siblingSeriesData_1.length; _i++) {
                var sibRow = siblingSeriesData_1[_i];
                if (!sibRow.x && sibRow.name === row.name) {
                    sibRow.x = index + positionFix_1;
                    break;
                }
            }
        });
        siblingSeriesData.filter(function (row) { return !row.x; }).forEach(function (row) {
            var rowCopy = __assign(__assign({}, row), { x: totalBars, y: 0 });
            siblingSeriesData.push(rowCopy);
            row.x = totalBars + positionFix_1;
            totalBars += 1;
        });
    }
    return totalBars;
}
exports.assignXValue = assignXValue;
function sortFunction(a, b) {
    return b.mean - a.mean;
}
function updateChartWidth(chartContainer, chartGot) {
    var containerWidth = chartContainer.clientWidth;
    chartGot.setSize(containerWidth, null);
}
function makeChartGraph(series, xAxis, yAxis, optionsGot) {
    var settings = optionsGot.settings, options = optionsGot.options;
    var highChartsContainer = document.getElementById("chartContainer");
    // highChartsContainer.style.height = "100%";
    highChartsContainer.style.width = "100%";
    var xAxisKey = xAxis['data'][xAxis['selected']]['key'];
    var xAxisDisplay = xAxis['data'][xAxis['selected']]['display'];
    var xAxisOptions = JSON.parse(xAxis['data'][xAxis['selected']]['options']);
    var yAxisKey = yAxis['data'][yAxis['selected']]['key'];
    var yAxisDisplay = yAxis['data'][yAxis['selected']]['display'];
    var yAxisOptions = JSON.parse(yAxis['data'][yAxis['selected']]['options']);
    var chartGot = Highcharts.chart('chartContainer', {
        chart: __assign({ type: "scatter", plotBackgroundColor: "#F1F1F7", zoomType: "xy" }, options),
        title: {
            text: yAxisDisplay + " vs " + xAxisDisplay + " by Project and Issue",
            // text: "eNPV vs Tornado Factor Swing by Project and Issue",
            align: "center"
        },
        yAxis: {
            gridLineWidth: 2,
            gridLineColor: "#ffffff",
            labels: {
                style: {
                    fontSize: "16px"
                },
                formatter: function () {
                    return Intl.NumberFormat("en-US", yAxisOptions ? yAxisOptions : {}).format(Number(this.value));
                }
            },
            title: {
                text: yAxisDisplay,
                // text: "eNPV ($M)",
                style: {
                    fontSize: "18px",
                    fontWeight: "bold"
                }
            }
        },
        xAxis: {
            // min: 0,
            // max: 82,
            gridLineWidth: 2,
            gridLineColor: "#ffffff",
            labels: {
                style: {
                    fontSize: "16px"
                },
                formatter: function () {
                    return Intl.NumberFormat("en-US", xAxisOptions ? xAxisOptions : {}).format(Number(this.value));
                }
            },
            title: {
                text: xAxisDisplay,
                // text: "Tornado Factor Swing ($M)",
                style: {
                    fontSize: "18px",
                    fontWeight: "bold"
                }
            },
            // tickPositions: [1, 4, 9, 16, 25, 36, 49, 64, 81],
            tickLength: 0,
            lineColor: "#ffffffff"
        },
        legend: {
            layout: "vertical",
            align: "right",
            verticalAlign: "middle",
            itemStyle: {
                fontSize: "15px"
            },
            symbolPadding: 15
        },
        tooltip: {
            enabled: settings.showTooltip,
            pointFormatter: function () {
                var xText = typeof this.x === 'number' ? this.x.toFixed(settings.decimals) : this.x;
                var yText = typeof this.y === 'number' ? this.y.toFixed(settings.decimals) : this.y;
                var expName = this.options.expName || '';
                var slope = typeof this.options.slope === 'number' ? this.options.slope.toFixed(settings.decimals) : this.options.slope;
                var xData = typeof this.options.xData === 'number' ? this.options.xData.toFixed(settings.decimals) : this.options.xData;
                var yData = typeof this.options.yData === 'number' ? this.options.yData.toFixed(settings.decimals) : this.options.yData;
                return "\n                x: <strong>" + xText + "</strong> <br/> \n                y: <strong>" + yText + "</strong> <br/> \n                Experiment: <strong>" + expName + "</strong> <br/>\n                " + xAxisDisplay + ": <strong>" + xData + "</strong> <br/>\n                " + yAxisDisplay + ": <strong>" + yData + "</strong> <br/>\n                Productivity: <strong>" + slope + "</strong> <br/>\n\n                \n                \n                ";
            }
        },
        series: series,
        responsive: {
            rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            enabled: false
                        }
                    }
                }]
        }
    });
    // window.addEventListener('resize', ()=> updateChartWidth(highChartsContainer, chartGot));
    return chartGot;
}
exports.makeChartGraph = makeChartGraph;
function getChartOptions(graph, options, xAxisData, yAxisData) {
    var chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp, chartInverted = options.chartInverted;
    var legendsEnabled = (options['legendsEnabled'] != false);
    var chartWidth = options['legendsEnabled'] == false ? 400 : 580;
    var marginRight = options['legendsEnabled'] == false ? 0 : 50;
    var marginTop = options['legendsEnabled'] == false ? 70 : 30;
    var mainFilteredData = filterExpWithImpIg(graph.mainRows) || [];
    var siblingFilteredData = filterExpWithImpIg(graph.siblingRows) || [];
    var calcDataMain = calculateCFO(mainFilteredData, xAxisData, yAxisData);
    var calcDataSibling = calculateCFO(siblingFilteredData, xAxisData, yAxisData);
    var mainSeriesData = getGroupedData(calcDataMain);
    var siblingSeriesData = getGroupedData(calcDataSibling);
    var totalBars = assignXValue(mainFilteredData, siblingFilteredData);
    var chartHeight = getChartHeight(totalBars);
    chartHeight = options['legendsEnabled'] == false ? chartHeight + 70 : 0;
    var series = generateSeries(mainSeriesData, xAxisData, yAxisData, settings);
    var drilldown = (graph.mainDrillDown || []).map(function (dd) {
        dd.data = breakDownSeries(dd.data);
        return dd;
    });
    if (siblingFilteredData.length > 0) {
        var siblingSeries = generateSeries(siblingSeriesData, xAxisData, yAxisData, settings);
        series = series.concat(siblingSeries);
        drilldown = drilldown.concat(graph.siblingDrillDown.map(function (dd) {
            dd.data = breakDownSeries(dd.data);
            return dd;
        }));
    }
    return {
        series: series,
        customised: true,
        options: {
            height: 600,
            // width: 1000,
            zoomType: 'xy'
        },
        settings: settings
    };
}
exports.getChartOptions = getChartOptions;
//# sourceMappingURL=cfo-exp.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/cfo-exp/cfo-exp.chart.js